import { cn } from '@mint-lib/tw-utils';

import { Button } from '../../lib/button.jsx';
import { RichTooltipContent } from '../../lib/rich-tooltip.jsx';
import { typographyVariants } from '../../lib/typography.jsx';

type RichTooltipWithButtonsContentProps = React.ComponentProps<
  typeof RichTooltipContent
> & {
  title?: string;
  description: React.ReactNode;
  primaryButtonProps?: React.ComponentProps<typeof Button>;
  secondaryButtonProps?: React.ComponentProps<typeof Button>;
};

function RichTooltipWithButtonsContent({
  title,
  description,
  primaryButtonProps,
  secondaryButtonProps,
  side = 'top',
  ...props
}: RichTooltipWithButtonsContentProps) {
  return (
    <RichTooltipContent
      {...props}
      side={side}
      className={cn('flex flex-col gap-4', props.className)}
    >
      <div className="flex flex-col gap-1">
        <h6 className={typographyVariants({ variant: 'h6', color: 'primary' })}>
          {title}
        </h6>
        <p
          className={typographyVariants({
            variant: 'bodyLong01',
            color: 'primary',
          })}
        >
          {description}
        </p>
      </div>
      {(primaryButtonProps || secondaryButtonProps) && (
        <div className="flex flex-row justify-between gap-4">
          {primaryButtonProps && (
            <Button {...primaryButtonProps} variant="plain">
              {primaryButtonProps.children}
            </Button>
          )}
          {secondaryButtonProps && (
            <Button {...secondaryButtonProps} variant="plain">
              {secondaryButtonProps.children}
            </Button>
          )}
        </div>
      )}
    </RichTooltipContent>
  );
}

export default RichTooltipWithButtonsContent;
